export const STATUS_ID = {
    DRAFT: '1e1fa784f2a911ec8bf4fa163e89e3c2', // ร่าง
    WAITING_FOR_REVIEW: '2940de90f2a911ec8bf4fa163e89e3c4', //รอตรวจสอบ
    REVIEWED: '14094f73f2a911ec8bf4fa163e89e3c1', //ตรวจสอบแล้ว
    REVISE: '23c31c18f2a911ec8bf4fa163e89e3c3', //ส่งคืนแก้ไข
};
